<template>
  <fragment>
    <div class="left-content">
      <div v-if="item.team === 'A'" class="content-outer">
        <div class="table-icon" v-b-tooltip.hover.top title="Blokkolt lövés"/>
        <div class="table-jersey">{{item.player.jersey}}</div>
        <div class="table-player">{{item.player.name}}</div>
      </div>
    </div>
    <div class="main-time">
      <div class="time-outer">
        {{item.scores}}
      </div>
    </div>
    <div class="right-content">
      <div v-if="item.team === 'B'" class="content-outer">
        <div class="table-player">{{item.player.name}}</div>
        <div class="table-jersey">{{item.player.jersey}}</div>
        <div class="table-icon" v-b-tooltip.hover.top title="Blokkolt lövés"/>
      </div>
    </div>
  </fragment>
</template>

<script>
export default {
  name: 'ItemBlokkolt',
  props: {
    item: Object,
  },
}
</script>

<style scoped>
.table-icon {
  position: relative;
  width: 32px; /* vagy ami kell */
  height: 32px;
  overflow: hidden;
}

.table-icon::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url('/icon/vedett.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transform: rotate(-90deg);
  transform-origin: center;
}

</style>